// Keeps a native checkbox's `indeterminate` DOM property in sync with an expression.
//
// ng-model cannot express a third state, so a checkbox whose value is not yet known can only render checked
// or unchecked — and unchecked is not a neutral "no value", it is a positive claim that the setting is off.
// `indeterminate` is HTML's own "unknown", and browsers map it to the accessible "mixed" state, so no
// aria-checked is needed (hand-setting one on a native checkbox would only drift from the real property).
//
// Creates no scope of its own, so it composes with ng-model / ng-change / ng-disabled on the same input.
// The watch goes on the element's own scope — never scope.$parent, which is how the vendored trumbowyg-ng
// directive leaks a watcher per teardown — so normal scope-destroy cleanup removes it.
//
// Usage:
//   <input type="checkbox"
//          data-ng-model="country.reveal_sponsor"
//          data-ng-disabled="survey_refreshing"
//          data-mat-indeterminate="survey_refreshing"/>
app.directive('matIndeterminate', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      scope.$watch(attrs.matIndeterminate, function (isUnknown) {
        element.prop('indeterminate', !!isUnknown);
      });
    }
  };
});
